import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import ProxiesPage from './pages/ProxiesPage';
import APIPage from './pages/APIPage';
import TopUpPage from './pages/TopUpPage';
import AdminPanel from './pages/AdminPanel';
import ReferralPage from './pages/ReferralPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
    <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            
            {/* Google Ads sitelinks - all render landing page with section scroll */}
            <Route path="/features" element={<LandingPage section="features" />} />
            <Route path="/pricing" element={<LandingPage section="pricing" />} />
            <Route path="/home" element={<LandingPage section="home" />} />
            
            <Route path="/login" element={<LoginPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/admin" element={<AdminPanel />} />
            
            {/* Protected routes */}
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/proxies" 
              element={
                <ProtectedRoute>
                  <ProxiesPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/api" 
              element={
                <ProtectedRoute>
                  <APIPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/topup" 
              element={
                <ProtectedRoute>
                  <TopUpPage />
                </ProtectedRoute>
              } 
            />
            
            {/* Referral partner dashboard — hidden route, only visible in sidebar for partners */}
            <Route 
              path="/referral" 
              element={
                <ProtectedRoute>
                  <ReferralPage />
                </ProtectedRoute>
              } 
            />
            
            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
    </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
